var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Watch, PropertyConverters, P, PCSS, Utils } from '@pacem/pacem-core';
import { PacemFxElement } from './types';
//namespace Pacem.Components.Fx {
const HERO_CSS = PCSS + "-hero";
const TRANSITION = 200;
const HEROING_IN = "entering";
const HEROING_OUT = "exiting";
const HERO_IN = "entered";
const HERO_OUT = "exited";
const rectOrElementConverter = {
    convert: attr => {
        if (attr.trim().startsWith('#'))
            return PropertyConverters.Element.convert(attr);
        return PropertyConverters.Json.convert(attr);
    }
};
let PacemFxHeroElement = class PacemFxHeroElement extends PacemFxElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        // target switch?
        if (name === 'target' && !Utils.isNull(old)) {
            this._resetTarget(old);
        }
        // recompute back path (originalState)?
        if (name === 'from' && this.hero && !Utils.isNull(val)) {
            this._originalState = this._computeFromState();
        }
        // trigger
        if (name === 'hero' || name === 'target' || name === 'goal') {
            if (!Utils.isNull(this.target)) {
                if (this.hero) {
                    this.start();
                }
                else {
                    this.reset();
                }
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (this.hero && !Utils.isNull(this.target))
            this.start();
    }
    disconnectedCallback() {
        if (!Utils.isNull(this.target))
            this.reset();
        super.disconnectedCallback();
    }
    _computeFromState() {
        const tget = this.target, offset = Utils.offset(tget);
        if (this.from instanceof Element) {
            let from = Utils.offset(this.from);
            return { x: from.left, y: from.top, width: from.width, height: from.height };
        }
        else {
            return { x: offset.left, y: offset.top, width: offset.width, height: offset.height };
        }
    }
    _resetTarget(tget = this.target) {
        // reset inline style options
        const style = tget.style;
        // reset position/size
        style.top = style.left = style.height = style.width = '';
        for (let j = 0; j < style.length; j++) {
            let prop = style.item(j);
            style[prop] = '';
        }
        for (let prop in this._originalStyle) {
            style[prop] = this._originalStyle[prop];
        }
        Utils.removeClass(tget, HERO_CSS);
    }
    reset() {
        //
        if (Utils.isNull(this._originalState) || Utils.isNull(this._targetState)) {
            return;
        }
        this.dispatchEvent(new Event(HEROING_OUT));
        return this._animate(this._targetState, this._originalState).then(() => {
            this._resetTarget();
            this.dispatchEvent(new Event(HERO_OUT));
        });
    }
    start() {
        if (!this.disabled && !Utils.isNull(this.target)) {
            let goal;
            if (this.to instanceof Element) {
                let to = Utils.offset(this.to);
                goal = { x: to.left, y: to.top, width: to.width, height: to.height };
            }
            else {
                goal = this.to;
            }
            const tget = this.target, wSize = Utils.windowSize, state = goal || { x: 0, y: 0, width: wSize.width, height: wSize.height }, style = tget.style;
            this._targetState = state;
            let start = this._originalState = this._computeFromState();
            // save inline style options
            this._originalStyle = {};
            for (let j = 0; j < style.length; j++) {
                let prop = style.item(j);
                this._originalStyle[prop] = style[prop];
            }
            //
            Utils.addClass(tget, HERO_CSS);
            this.dispatchEvent(new Event(HEROING_IN));
            return this._animate(start, state).then(() => {
                this.dispatchEvent(new Event(HERO_IN));
            });
        }
        // nothing to do
        return Promise.resolve();
    }
    _animate(from, to) {
        const tget = this.target, style = tget.style;
        // transformations to make target state look like original state
        // i.e. `target state` gets constrained to fit `original state`.
        const scaleX = from.width / to.width, scaleY = from.height / to.height, translateX = (from.x - to.x) + 'px', translateY = (from.y - to.y) + 'px';
        style.transformOrigin = '0 0';
        style.transition = 'none';
        // set final state
        style.transform = `translate(${translateX}, ${translateY}) scale(${scaleX}, ${scaleY})`;
        style.width = to.width + 'px';
        style.height = to.height + 'px';
        style.top = to.y + 'px';
        style.left = to.x + 'px';
        // hero-animate
        requestAnimationFrame(() => {
            let duration = this.duration || TRANSITION;
            style.transition = `transform cubic-bezier(0.445, 0.05, 0.55, 0.95) ${duration}ms, opacity ${duration}ms`;
            style.transform = `translate(0, 0) scale(1)`;
        });
        return Utils.waitForAnimationEnd(tget, TRANSITION + 10);
        // Utils.addAnimationEndCallback(tget, callback, TRANSITION + 10);
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemFxHeroElement.prototype, "hero", void 0);
__decorate([
    Watch({ converter: rectOrElementConverter, emit: false })
], PacemFxHeroElement.prototype, "to", void 0);
__decorate([
    Watch({ converter: rectOrElementConverter, emit: false })
], PacemFxHeroElement.prototype, "from", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number, emit: false })
], PacemFxHeroElement.prototype, "duration", void 0);
PacemFxHeroElement = __decorate([
    CustomElement({ tagName: P + '-fx-hero' })
], PacemFxHeroElement);
export { PacemFxHeroElement };
